import * as bl06 from '../actions/bl06.actions';

export interface State {
    page_content: any;
}
export const initialState = {
    page_content: {}
};

export function reducer(state = initialState, action: bl06.Actions) {
  switch (action.type) {
    case bl06.GO_TO_PAGE_BL06: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        page_content: {
          data: data.data,
          noOfRecords: data.noOfRecords,
        },
        page_list: {
          roleList: data.roleList,
          hierarchyList: data.hierarchyList,
        }
      });
    }

    default:
      return state;
  }
}

function transformResponse(data) {
  return {
    noOfRecords: data[0] ? data[0]['noOfRecords'] : 0,
    // noOfRecords: data[0]['noOfRecords'] || 0,
    data: data[0] ? data[0].brokerOrTRInfo.map(e => {
    // data: data[0].brokerOrTRInfo ? data[0].brokerOrTRInfo.map(e => {
      return {
        BL06_09: e['username'],
        BL06_10: e['agentFirstName'],
        BL06_11: e['agentLastName'],
        BL06_12: e['brokerName'],
        BL06_13: e['roleID'],
        BL06_14: e['hierID'],
        BL06_15: e['status'],
        'isChecked': false,
      };
    }) : [],
    roleList: data[1].roleList ? data[1].roleList.map(e => {
      return {
        roleName: e['roleName'],
        roleId: e['v_ROLE_ID'],
      };
    }) : [],
    hierarchyList: data[2].hierarchyList ? data[2].hierarchyList.map(e => {
      return {
        hierarchyName: e['hierarchyName'],
        hierarchyId: e['v_HIER_ID'],
      };
    }) : 0,
  };
}
